import React, { ReactNode } from 'react';
import { faInfoCircle } from '@fortawesome/pro-regular-svg-icons/faInfoCircle';
import { TYPE } from '@kontentino/kontentino-constants/Pages';
import { Tooltip, Icon } from '@kontentino/ui';
import i18n from 'app/utils/i18n';

export const AUDIENCE_RESTRINCTION_EMPTY_VALUE = {
  get label() {
    return i18n.t('audienceRestrictions.everyone');
  },
  value: '',
};

export const AUDIENCE_RESTRICTIONS_AGES = [
  AUDIENCE_RESTRINCTION_EMPTY_VALUE,
  {
    label: '13+',
    value: 13,
  },
  {
    label: '17+',
    value: 17,
  },
  {
    label: '18+',
    value: 18,
  },
  {
    label: '19+',
    value: 19,
  },
  {
    label: '21+',
    value: 21,
  },
];

export enum AudienceRestrictionField {
  cities = 'cities',
  countries = 'countries',
  fbCountryGroups = 'country_groups',
  lnCountryGroups = 'countryGroups',
  regions = 'regions',
  locales = 'locales',
  languages = 'languages',
  ageMin = 'age_min',
}

export enum FormTab {
  RestrictedAudience,
  NewsFeedTargeting,
  Presets,
}

export const getPageTypeFormFields = (): Record<
  FormTab,
  Partial<
    Record<
      number,
      {
        label: ReactNode;
        type: AudienceRestrictionField;
        placeholder?: string;
        isSingle?: boolean;
      }[]
    >
  >
> => ({
  [FormTab.RestrictedAudience]: {
    [TYPE.FACEBOOK]: [
      {
        label: i18n.t('audienceRestrictions.ages'),
        type: AudienceRestrictionField.ageMin,
        isSingle: true,
      },
      {
        label: i18n.t('audienceRestrictions.countries'),
        placeholder: i18n.t('audienceRestrictions.countriesPlaceholder'),
        type: AudienceRestrictionField.countries,
      },
      {
        label: (
          <span className="tw-flex tw-items-center tw-gap-1">
            {i18n.t('audienceRestrictions.cities')}{' '}
            <Tooltip
              content={i18n.t(
                'audienceRestrictions.overlappingLocationsWarning',
              )}
            >
              <Icon
                icon={faInfoCircle}
                size="sm"
                className="tw-text-grayscale-90"
              />
            </Tooltip>
          </span>
        ),
        placeholder: i18n.t('audienceRestrictions.citiesPlaceholder'),
        type: AudienceRestrictionField.cities,
      },
      {
        label: i18n.t('audienceRestrictions.countryGroups'),
        placeholder: i18n.t('audienceRestrictions.countryGroupsPlaceholder'),
        type: AudienceRestrictionField.fbCountryGroups,
      },
      {
        label: i18n.t('audienceRestrictions.regions'),
        placeholder: i18n.t('audienceRestrictions.regionsPlaceholder'),
        type: AudienceRestrictionField.regions,
      },
    ],
    [TYPE.LINKEDIN]: [
      {
        label: i18n.t('audienceRestrictions.countries'),
        placeholder: i18n.t('audienceRestrictions.countriesPlaceholder'),
        type: AudienceRestrictionField.countries,
      },
      {
        label: i18n.t('audienceRestrictions.countryGroups'),
        placeholder: i18n.t('audienceRestrictions.countryGroupsPlaceholder'),
        type: AudienceRestrictionField.lnCountryGroups,
      },
      {
        label: i18n.t('audienceRestrictions.interfaceLanguages'),
        placeholder: i18n.t(
          'audienceRestrictions.interfaceLanguagesPlaceholder',
        ),
        type: AudienceRestrictionField.languages,
      },
    ],
  },
  [FormTab.NewsFeedTargeting]: {
    [TYPE.FACEBOOK]: [
      {
        label: i18n.t('audienceRestrictions.languages'),
        placeholder: i18n.t('audienceRestrictions.languagesPlaceholder'),
        type: AudienceRestrictionField.locales,
      },
    ],
  },
  [FormTab.Presets]: {
    [TYPE.FACEBOOK]: [],
    [TYPE.LINKEDIN]: [],
  },
});
